define("influencers/routes", ["exports", "ember-engines/routes"], function (_exports, _routes) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-engines/routes"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _routes.default)(function () {
    this.route('profile', {
      path: 'profile/:social_identity_id'
    }, function () {
      this.route('edit');
      this.route('opt-in');
      this.route('join');
      this.route('unsubscribe');
      this.route('create-influencer');
      this.route('settings');
      this.route('notifications');
      this.route('manage-campaigns', function () {
        this.route('campaign', {
          path: '/:campaign_id'
        });
      });
      // Legacy campaigns
      this.route('campaigns', function () {
        this.route('campaign', {
          path: '/:campaign_id'
        });
      });
      // OCE Campaigns
      this.route('view-campaigns', function () {
        this.route('campaign', {
          path: '/:campaign_id'
        }, function () {
          this.route('application-answers');
          this.route('draft-submission', function () {
            this.route('draft', {
              path: '/:thread_id'
            });
          });
          this.route('deliverables', function () {
            this.route('deliverable', {
              path: '/:deliverable_id'
            });
          });
          this.route('product-review', function () {
            this.route('review', {
              path: '/:review_id'
            });
          });
          this.route('status');
        });
      });
      // OCE Surveys
      this.route('surveys', function () {
        this.route('survey', {
          path: '/:survey_id'
        });
      });
    });
    this.route('profiles', {
      path: 'profiles/:social_identity_id'
    }, function () {
      this.route('terms');
      this.route('overview');
      this.route('creators', function () {
        this.route('search');
        this.route('saved');
      });
      this.route('campaigns', function () {
        this.route('create');
        this.route('campaign', {
          path: '/:campaign_id'
        }, function () {
          this.route('edit');
          this.route('unsubscribe');
        });
      });
      this.route('archived', function () {
        this.route('campaign', {
          path: '/:campaign_id'
        });
      });
    });
    this.route('creator-connect');
    this.route('brand-connect');
    this.route('campaign-application', function () {
      this.route('application-form', {
        path: '/:campaign_id'
      });
    });
  });
});